import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/dropdown-navigation';

import './style.scss';

// tslint:disable-next-line
register('service-dropdown', () => import(/* webpackMode: "lazy" */'./service-dropdown'));
